var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"users d-flex flex-column"},[_c('base-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"store-option-id":"homeUsersUserTable","show-search":""},scopedSlots:_vm._u([{key:"item-preview",fn:function(ref){
var item = ref.item;
return [_c('user',{staticClass:"ma-3",attrs:{"user":item.avatar,"disabled":""}}),_c('span',[_vm._v(_vm._s(item.preview))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }